import { render } from "./BaseNotificator.vue?vue&type=template&id=3cee83e6"
import script from "./BaseNotificator.vue?vue&type=script&lang=js"
export * from "./BaseNotificator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__